import galaxyAnnotations from '../data/seed/galaxy-annotations.json' with { type: 'json' };

export const SEO_ORIGIN = 'https://ovi-stats.ru';
export const SEO_SITE_NAME = 'OVI Stats';
export const SEO_IMAGE = `${SEO_ORIGIN}/media/server/ovechkin-hero.jpg`;

const DEFAULT_ROBOTS = 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1';
const PRIVATE_ROBOTS = 'noindex,nofollow,noarchive';

const pages = {
  '/': {
    title: 'Рекорды Александра Овечкина — полная база | OVI Stats',
    description: 'Самая полная база рекордов Александра Овечкина: голы в равных составах, большинстве и меньшинстве, тройки лучших игроков и постоянно обновляемые данные.',
    h1: 'Рекорды Александра Овечкина',
  },
  '/records': {
    title: 'Рекорды Александра Овечкина | OVI Stats',
    description: 'Каталог рекордов Александра Овечкина по галактикам: полные названия, этапы и тройки лучших игроков с актуальными значениями.',
    h1: 'Каталог рекордов Александра Овечкина',
    breadcrumb: 'Рекорды',
  },
  '/news': {
    title: 'Новости Александра Овечкина и разборы | OVI Stats',
    description: 'Новости Александра Овечкина, обновления статистики, факты и редакционные разборы с датами публикации и ссылками на источники.',
    h1: 'Новости Александра Овечкина',
    breadcrumb: 'Новости',
  },
  '/protocols': {
    title: 'Протоколы рекордов Овечкина по матчам | OVI Stats',
    description: 'Рекорды Александра Овечкина после каждого матча: новые достижения, обновления и изменения в тройках лучших со ссылками на каталог рекордов.',
    h1: 'Протоколы рекордов',
    breadcrumb: 'Протоколы',
  },
  '/predictions': {
    title: 'Прогнозы и аналитика об Александре Овечкине | OVI Stats',
    description: 'Редакционные прогнозы об Александре Овечкине и матчах Вашингтона: обоснование, уровень уверенности и дата каждой оценки.',
    h1: 'Прогнозы и аналитика',
    breadcrumb: 'Прогнозы',
  },
  '/calendar': {
    title: 'Календарь матчей НХЛ 2026/27 — все команды | OVI Stats',
    description: 'Открытый календарь матчей НХЛ сезона 2026/27: все команды, даты, время и фильтры. Бесплатно и без регистрации.',
    h1: 'Календарь матчей НХЛ',
    breadcrumb: 'Календарь',
  },
  '/support': {
    title: 'Поддержать открытый проект OVI Stats',
    description: 'OVI Stats открыт для всех: рекорды, новости, прогнозы и календарь доступны бесплатно и без регистрации. Поддержка проекта добровольна.',
    h1: 'Поддержать OVI Stats',
    breadcrumb: 'Поддержка проекта',
  },
};

const privatePages = {
  '/login': { title: 'Вход для редакции | OVI Stats', description: 'Вход в редакционную панель OVI Stats. Читателям аккаунт не нужен.', h1: 'Вход для редакции' },
  '/account': { title: 'Профиль редакции | OVI Stats', description: 'Профиль редактора OVI Stats.', h1: 'Профиль редакции' },
};

function normalizePathname(value) {
  const pathname = String(value || '/').split('?')[0] || '/';
  return pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname;
}

function withDefaults(pathname, page) {
  return {
    status: 200,
    pathname,
    title: page.title,
    description: page.description,
    h1: page.h1,
    canonical: `${SEO_ORIGIN}${pathname === '/' ? '/' : pathname}`,
    image: SEO_IMAGE,
    robots: DEFAULT_ROBOTS,
    type: 'website',
    breadcrumb: page.breadcrumb || null,
  };
}

export function seoForPathname(value) {
  const pathname = normalizePathname(value);
  if (pathname === '/records') {
    const params = new URLSearchParams(String(value).split('?')[1] || '');
    const slug = params.get('galaxy');
    const galaxy = slug ? galaxyAnnotations.items.find((item) => item.slug === slug) : null;
    if (slug && !galaxy) return seoForPathname('/not-found');
    const seo = withDefaults(pathname, galaxy ? {
      title: `${galaxy.name} — рекорды Овечкина | OVI Stats`,
      description: `${galaxy.description}. Галактика «${galaxy.name}»: рекорды Александра Овечкина, показатели и тройки лучших игроков. Открыто без регистрации.`,
      h1: `${galaxy.name} — рекорды Александра Овечкина`,
      breadcrumb: galaxy.name,
    } : pages[pathname]);
    if (galaxy) {
      seo.galaxySlug = slug;
      seo.canonical += `?galaxy=${encodeURIComponent(slug)}`;
    }
    if (params.get('q') || params.get('stage') || params.get('position') || Number(params.get('page')) > 1 || (params.has('pageSize') && params.get('pageSize') !== '20')) {
      seo.robots = 'noindex,follow';
      seo.canonical = null;
    }
    return seo;
  }
  if (pathname === '/protocols') {
    const seo = withDefaults(pathname, pages[pathname]);
    const params = new URLSearchParams(String(value).split('?')[1] || '');
    if (Number(params.get('page')) > 1) { seo.robots = 'noindex,follow'; seo.canonical = null; }
    return seo;
  }
  if (/^\/protocols\/\d+$/.test(pathname)) return withDefaults(pathname, {
    title: 'Протокол рекордов Овечкина | OVI Stats',
    description: 'Новые рекорды и изменения в таблицах Александра Овечкина по итогам матча.',
    h1: 'Протокол рекордов', breadcrumb: 'Протокол матча',
  });
  if (pages[pathname]) return withDefaults(pathname, pages[pathname]);
  if (/^\/news\/[^/]+$/.test(pathname)) return withDefaults(pathname, {
    title: 'Новость об Александре Овечкине | OVI Stats',
    description: 'Новости и актуальные материалы об Александре Овечкине на OVI Stats.',
    h1: 'Новость об Александре Овечкине',
    breadcrumb: 'Новости',
  });
  if (/^\/records\/\d+$/.test(pathname)) return {
    ...withDefaults(pathname, {
      title: 'Рекорд Александра Овечкина | OVI Stats',
      description: 'Карточка рекорда Александра Овечкина в каталоге OVI Stats.',
      h1: 'Рекорд Александра Овечкина',
      breadcrumb: 'Рекорды',
    }),
    robots: DEFAULT_ROBOTS,
  };
  if (privatePages[pathname]) return { ...withDefaults(pathname, privatePages[pathname]), canonical: null, robots: PRIVATE_ROBOTS };
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return {
    ...withDefaults(pathname, { title: 'Редакционная панель | OVI Stats', description: 'Закрытая редакционная панель OVI Stats.', h1: 'Редакционная панель OVI Stats' }),
    canonical: null,
    robots: PRIVATE_ROBOTS,
  };
  return {
    ...withDefaults(pathname, { title: 'Страница не найдена | OVI Stats', description: 'Запрошенная страница не найдена.', h1: 'Страница не найдена' }),
    status: 404,
    canonical: null,
    robots: PRIVATE_ROBOTS,
  };
}

export function structuredDataFor(seo) {
  const organizationId = `${SEO_ORIGIN}/#organization`;
  const websiteId = `${SEO_ORIGIN}/#website`;
  const graph = [
    {
      '@type': 'Organization', '@id': organizationId, name: SEO_SITE_NAME, alternateName: 'OVI Stats — рекорды Овечкина',
      url: `${SEO_ORIGIN}/`, logo: { '@type': 'ImageObject', url: `${SEO_ORIGIN}/favicon-120.png`, width: 120, height: 120 },
    },
    {
      '@type': 'WebSite', '@id': websiteId, url: `${SEO_ORIGIN}/`, name: SEO_SITE_NAME,
      alternateName: 'Рекорды Александра Овечкина', inLanguage: 'ru-RU', publisher: { '@id': organizationId },
      potentialAction: { '@type': 'SearchAction', target: `${SEO_ORIGIN}/records?q={search_term_string}`, 'query-input': 'required name=search_term_string' },
    },
  ];
  if (seo.canonical) graph.push({
    '@type': seo.article ? 'NewsArticle' : 'WebPage', '@id': `${seo.canonical}#webpage`, url: seo.canonical,
    name: seo.title, headline: seo.article?.headline, description: seo.description, inLanguage: 'ru-RU',
    isPartOf: { '@id': websiteId }, publisher: { '@id': organizationId },
    primaryImageOfPage: { '@type': 'ImageObject', url: seo.image || SEO_IMAGE },
    ...(seo.article ? {
      datePublished: seo.article.datePublished, dateModified: seo.article.dateModified,
      author: { '@id': organizationId }, image: [seo.image || SEO_IMAGE], mainEntityOfPage: seo.canonical,
    } : {}),
    ...(seo.pathname === '/' ? { about: { '@type': 'Person', name: 'Александр Овечкин' } } : {}),
  });
  if (seo.breadcrumb && seo.canonical) graph.push({
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: `${SEO_ORIGIN}/` },
      { '@type': 'ListItem', position: 2, name: seo.breadcrumb, item: seo.canonical },
    ],
  });
  return { '@context': 'https://schema.org', '@graph': graph };
}

function upsertMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    document.head.append(element);
  }
  for (const [name, value] of Object.entries(attributes)) element.setAttribute(name, value);
}

export function applyDocumentSeo(seo) {
  if (typeof document === 'undefined') return;
  document.title = seo.title;
  upsertMeta('meta[name="description"]', { name: 'description', content: seo.description });
  upsertMeta('meta[name="robots"]', { name: 'robots', content: seo.robots });
  upsertMeta('meta[property="og:type"]', { property: 'og:type', content: seo.article ? 'article' : 'website' });
  upsertMeta('meta[property="og:title"]', { property: 'og:title', content: seo.title });
  upsertMeta('meta[property="og:description"]', { property: 'og:description', content: seo.description });
  upsertMeta('meta[property="og:image"]', { property: 'og:image', content: seo.image || SEO_IMAGE });
  upsertMeta('meta[property="og:image:width"]', { property: 'og:image:width', content: '1200' });
  upsertMeta('meta[property="og:image:height"]', { property: 'og:image:height', content: '630' });
  upsertMeta('meta[property="og:image:alt"]', { property: 'og:image:alt', content: seo.h1 });
  upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
  upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: seo.title });
  upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: seo.description });
  upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: seo.image || SEO_IMAGE });
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (seo.canonical) {
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.append(canonical); }
    canonical.href = seo.canonical;
    upsertMeta('meta[property="og:url"]', { property: 'og:url', content: seo.canonical });
  } else {
    canonical?.remove();
    document.head.querySelector('meta[property="og:url"]')?.remove();
  }
  let schema = document.getElementById('seo-jsonld');
  if (!schema) { schema = document.createElement('script'); schema.id = 'seo-jsonld'; schema.type = 'application/ld+json'; document.head.append(schema); }
  schema.textContent = JSON.stringify(structuredDataFor(seo));
}
